import React from 'react';
import styled, {css} from 'styled-components';


const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

const StyledItem = styled.a`
     width: 100%;

     display: grid;
     grid-template-columns: 175px auto;
     
     gap:10px;
     align-items: center;
     cursor: pointer;
     color:var(--color-gray-dark);
     &:hover{
          color: var(--color-gray-dark);
          text-decoration: none;
          .text .content{
               text-decoration: underline;
          }
     }

    @media (max-width: 600px) {
          grid-template-columns: auto;
    }

     .text{
          .content{
               
          }
          .fecha{
              font-weight: bold;
              font-size: 14px;
          }          
     }


     img{max-width:100%}
`

export default React.forwardRef((props:any, ref) => {
    return (
          <StyledItem onClick={props?.onClick}>
               <div className='image'>
                    <img src={props.file_name_url} /> 
               </div>
               <div className='text'>
                    <p className='content'>{props.mensaje}</p>
                    <p className='fecha'>{moment(props?.fecha).format('D [de] MMMM [del] YYYY [a las] HH:mm')}</p>
               </div>
          </StyledItem>
    )
});